import { Injectable } from '@angular/core';
import { ProcessedError } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  constructor() {}

  getError(code: number, message: string): ProcessedError {
    return {
      statusCode: code,
      errorMessage: message || 'Ha ocurrido un error.',
    };
  }
}
